import * as z from "zod";
//#region src/__generated__/internal/approval/zod/reassignRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const reassignRequestSchema = z.object({
	assigneeId: z.uuid().describe("Идентификатор нового исполнителя"),
	reason: z.string().optional().describe("Причина переназначения (попадает в журнал событий)")
}).describe("Переназначение слота участника");
//#endregion
//#region src/__generated__/internal/approval/zod/approverDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const approverDtoSchema = z.object({
	email: z.string().nullish().describe("Email согласующего").meta({ examples: ["approver@example.com"] }),
	firstName: z.string().nullish().describe("Имя").meta({ examples: ["Пётр"] }),
	internalUserId: z.uuid().nullish().describe("Идентификатор внутреннего пользователя").meta({ examples: ["550e8400-e29b-41d4-a716-446655440000"] }),
	lastName: z.string().nullish().describe("Фамилия").meta({ examples: ["Петров"] }),
	middleName: z.string().nullish().describe("Отчество").meta({ examples: ["Петрович"] })
}).describe("Данные согласующего из Keycloak");
//#endregion
//#region src/__generated__/internal/approval/zod/stageAssignmentDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const stageAssignmentDtoSchema = z.object({
	assignedAt: z.iso.datetime().nullish(),
	assignedBy: z.uuid().nullish(),
	assignee: approverDtoSchema.nullish().describe("Данные согласующего из Keycloak"),
	reason: z.string().nullish(),
	slot: z.enum([
		"NG_STAFF",
		"NTP_HEAD",
		"NTP_RESPONSIBLE"
	]).optional()
}).describe("Занятый слот участника процесса");
//#endregion
//#region src/__generated__/internal/approval/zod/reassignSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const reassignPathRequestIdSchema = z.uuid();
const reassignPathSlotSchema = z.enum([
	"NG_STAFF",
	"NTP_HEAD",
	"NTP_RESPONSIBLE"
]);
const reassignStatus200Schema = stageAssignmentDtoSchema.describe("Занятый слот участника процесса");
const reassignResponseSchema = reassignStatus200Schema;
const reassignDataSchema = reassignRequestSchema.describe("Переназначение слота участника");
//#endregion
export { reassignStatus200Schema as a, reassignRequestSchema as c, reassignResponseSchema as i, reassignPathRequestIdSchema as n, stageAssignmentDtoSchema as o, reassignPathSlotSchema as r, approverDtoSchema as s, reassignDataSchema as t };

//# sourceMappingURL=reassignSchema.js.map